<div class="text">
  {{ 'HEADER.ONLINE' | translate | titlecase }}
</div>
<div class="count">
  {{ count }}
</div>
